export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode == 'dark';

  return {
    wrapper: {
      width: '100%',
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      overflow: 'hidden',
    },
    modalHeader: {
      display: 'flex',
      flexShrink: 0,
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '16px',
    },
    topContent: {
      display: 'flex',
      flexDirection: 'column',
      flexShrink: 0,
    },
    navigationSection: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      mt: '0.5rem',
      overflow: 'hidden',
    },
    modalTitle: {
      fontSize: '20px',
      fontWeight: 500,
      lineHeight: '160%',
      letterSpacing: '0.15px',
      color: theme?.palette?.text?.primary,
    },
    modalClose: {
      color: isDark ? '#FFFFFF8F' : theme?.palette?.grey?.[500],
      flexShrink: 0,
    },
  };
};
